import { render, staticRenderFns } from "./PersonalInformationView3.vue?vue&type=template&id=37994d48&scoped=true&"
import script from "./PersonalInformationView3.vue?vue&type=script&lang=js&"
export * from "./PersonalInformationView3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37994d48",
  null
  
)

export default component.exports